// extracted by mini-css-extract-plugin
module.exports = {"popover__wrapper":"popover__wrapper","popover__childrenWrapper":"popover__childrenWrapper","popover__closeButton":"popover__closeButton"};